import request from '../request'
import exportRequest from '../request-fetch'

const DictionaryTrainApi = {}

const prefix = ''

/**
 * 培训班列表
 */
DictionaryTrainApi.getTrainList = param => {
  return request({
    url: '/function/train/list',
    method: 'GET',
    params: param
  })
}

/**
 * 新增培训信息
 */
DictionaryTrainApi.addTrainInfo = param => {
  return request({
    url: '/function/train',
    method: 'POST',
    data: param
  })
}

/**
 * 根据Id 获取培训班详细信息
 */
DictionaryTrainApi.queryDetailById = param => {
  return request({
    url: '/function/train',
    method: 'GET',
    params: param
  })
}

/**
 * 置顶
 */
DictionaryTrainApi.setToTop = param => {
  return request({
    url: '/function/train/setTopOne',
    method: 'GET',
    params: param
  })
}

/**
 * 更新数据
 */
DictionaryTrainApi.updateDetailTrain = params => {
  return request({
    url: '/function/train',
    method: 'PUT',
    data: params
  })
}

/**
 * 删除一条培训信息
 */
DictionaryTrainApi.deleteTrainById = params => {
  return request({
    url: '/function/train/remove',
    method: 'POST',
    data: params
  })
}
//= =================================================================================
/**
 * 查询培训班报名信息及发票信息列表 /function/trainRegist/list
 */
DictionaryTrainApi.getTrainRegistList = param => {
  return request({
    url: '/function/trainRegist/list',
    method: 'GET',
    params: param
  })
}

/**
 * 根据ID 查询培训班报名信息 及详情
 */
DictionaryTrainApi.queryDetailApplyById = param => {
  return request({
    url: '/function/trainRegist',
    method: 'GET',
    params: param
  })
}

/**
 * 更新数据
 */
DictionaryTrainApi.updateDetail = params => {
  return request({
    url: '/function/trainRegist',
    method: 'PUT',
    data: params
  })
}
/**
 * 删除培训班报名信息及发票信息
 */
DictionaryTrainApi.deleteTrainRegist = param => {
  return request({
    url: '/function/trainRegist/remove',
    method: 'POST',
    data: param
  })
}

/**
 * 导出报名表及培训班信息
 */
DictionaryTrainApi.exportTrainInfo = param => {
  return request({
    url: '/function/trainRegist/export',
    method: 'GET',
    params: param
  })
}

/**
 * 下载通用
 */
DictionaryTrainApi.downLoadData = param => {
  return exportRequest(prefix + '/common/download', {

    // url: '/common/download/ajax',
    method: 'GET',
    params: param
    // responseType: 'blob'
  })
}

// 上传接口
DictionaryTrainApi.upLoadData = param => {
  return request({
    url: '/common/upload',
    method: 'POST',
    data: param
  })
}

export default DictionaryTrainApi
